import React from 'react';
import Button from 'components/Button';

const CheckoutButton = ({ showSpinner, title, ...rest }) => (
  <Button
    {...rest}
    type="submit"
    title={title}
    showSpinner={showSpinner}
  />
);

CheckoutButton.defaultProps = {
  className: 'btn-blue lg:w-64 w-full p-4 text-base lg:self-end my-9'
}

export default CheckoutButton;
